// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d1-3";
export var flatBottomCorners = "_d1-5";
export var productImage = "_d1-0";
export var quantityContainer = "_d1-2";
export var quantityHeader = "_d1-6";
export var tooltip = "_d1-1";
export var wrapAndEllipsesOverflow = "_d1-4";